const ITEMS = [
    "Corte Nobre",
    "Barba & Cabelo",
    "João Pessoa · PB",
    "Estilo Soberano",
    "Barboterapia",
    "Precisão Cirúrgica",
];

export default function Marquee() {
    return (
        <div className="relative border-y border-gold/15 bg-charcoal py-6 overflow-hidden select-none">
            <div className="marquee-track">
                {[0, 1].map((copy) => (
                    <div
                        key={copy}
                        aria-hidden={copy === 1}
                        className="flex items-center shrink-0"
                    >
                        {ITEMS.map((t) => (
                            <span key={t} className="flex items-center shrink-0">
                                <span className="font-display text-2xl sm:text-3xl uppercase tracking-[0.22em] text-cream/75 px-7">
                                    {t}
                                </span>
                                <span className="text-gold text-lg" aria-hidden="true">
                                    ✦
                                </span>
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
